import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-formula-icon',
  templateUrl: 'formula-icon.component.html'
})
export class FormulaIconComponent {
  constructor() {}
}
